/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Trigger syncs with Prefect", description = "Learn how to trigger syncs with Prefect's Hightouch Tasks.", lastUpdatedDate = new Date(1675728000000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Trigger syncs with Prefect",
        description: "Learn how to trigger syncs with Prefect's Hightouch Tasks.",
        lastUpdatedDate: "Tue Feb 07 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }, {
          "value": "Setup",
          "depth": 0,
          "id": "setup"
        }, {
          "value": "Create an API key",
          "depth": 1,
          "id": "create-an-api-key"
        }, {
          "value": "Set sync schedule type",
          "depth": 1,
          "id": "set-sync-schedule-type"
        }, {
          "value": "Usage",
          "depth": 0,
          "id": "usage"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      strong: "strong",
      a: "a",
      ul: "ul",
      li: "li",
      h3: "h3"
    }, _provideComponents(), props.components), {CreateAPIKeySnippet, APIKeyWarning, SetSyncSchedule} = _components;
    if (!APIKeyWarning) _missingMdxReference("APIKeyWarning", true);
    if (!CreateAPIKeySnippet) _missingMdxReference("CreateAPIKeySnippet", true);
    if (!SetSyncSchedule) _missingMdxReference("SetSyncSchedule", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsxs(_components.p, {
        children: ["Prefect provides native ", _jsx(_components.strong, {
          children: "tasks"
        }), " to interact with Hightouch. Check out the ", _jsx(_components.a, {
          href: "https://github.com/PrefectHQ/prefect-hightouch",
          children: "Git repository"
        }), " for examples and ", _jsx(_components.a, {
          href: "https://docs-v1.prefect.io/api/latest/tasks/hightouch.html#hightouchrunsync",
          children: "Prefect's API reference"
        }), " for usage details."]
      }), "\n", _jsx(_components.h2, {
        id: "setup",
        children: "Setup"
      }), "\n", _jsx(_components.p, {
        children: "To use Prefect's tasks you need:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "A Hightouch API key"
        }), "\n", _jsx(_components.li, {
          children: "The sync IDs of the syncs you want to trigger using Prefect"
        }), "\n"]
      }), "\n", _jsx(_components.h3, {
        id: "create-an-api-key",
        children: "Create an API key"
      }), "\n", _jsx(_components.p, {
        children: "The first step is to create a Hightouch API key in your Hightouch workspace settings."
      }), "\n", _jsx(CreateAPIKeySnippet, {}), "\n", _jsx(APIKeyWarning, {}), "\n", _jsx(_components.h3, {
        id: "set-sync-schedule-type",
        children: "Set sync schedule type"
      }), "\n", _jsx(SetSyncSchedule, {
        extension: "Prefect"
      }), "\n", _jsx(_components.h2, {
        id: "usage",
        children: "Usage"
      }), "\n", _jsxs(_components.p, {
        children: ["Refer to Prefect's ", _jsx(_components.a, {
          href: "https://github.com/PrefectHQ/prefect-hightouch",
          children: "Hightouch Git repository"
        }), " for the most up-to-date examples and instructions."]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
